export default __webpack_public_path__ + "static/media/image3.29a53a8d.jpg";